import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { surveysApi } from '../../api/surveys';
import type { Survey, SurveyPageResponse, SurveyResponses } from '../../types/surveys/publicSurvey.types';

// Fetch survey details
export const usePublicSurvey = (eventSlug: string, surveySlug: string) => {
  return useQuery<Survey>({
    queryKey: ['publicSurvey', eventSlug, surveySlug],
    queryFn: () => surveysApi.getSurvey(eventSlug, surveySlug),
    enabled: !!eventSlug && !!surveySlug,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

// Fetch survey page data
export const useSurveyPage = (eventSlug: string, surveySlug: string, pageIndex: number, enabled: boolean = true) => {
  return useQuery<SurveyPageResponse>({
    queryKey: ['surveyPage', eventSlug, surveySlug, pageIndex],
    queryFn: () => surveysApi.getSurveyPage(eventSlug, surveySlug, pageIndex),
    enabled: !!eventSlug && !!surveySlug && enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

// Submit survey
export const useSubmitSurvey = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ eventSlug, surveySlug, responses }: {
      eventSlug: string;
      surveySlug: string;
      responses: SurveyResponses;
    }) => surveysApi.submitSurvey(eventSlug, surveySlug, responses),
    onSuccess: (data, variables) => {
      // Invalidate survey query to update hasAlreadyResponded
      queryClient.invalidateQueries({ 
        queryKey: ['publicSurvey', variables.eventSlug, variables.surveySlug] 
      });
    },
  });
};